import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';

const STORAGE_KEY = 'todoenbalance_cookie_consent_v1';

const CookieBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        setVisible(true);
      }
    } catch {
      // ignore storage errors
    }
  }, []);

  const handleChoice = (choice) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, timestamp: new Date().toISOString() })
      );
    } catch {
      // ignore storage errors
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label={t('legal.cookieBannerTitle', 'Privacy & Cookie Notice')}
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:left-6 max-w-4xl mx-auto z-50 bg-gray-900/95 backdrop-blur-md text-white rounded-2xl shadow-2xl border border-gray-700 p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
    >
      <div className="flex items-start gap-3.5">
        <div className="w-10 h-10 rounded-xl bg-emerald-500/20 text-emerald-400 flex items-center justify-center flex-shrink-0 mt-0.5">
          <ShieldCheck className="w-5 h-5" />
        </div>
        <div className="text-xs sm:text-sm text-gray-300 leading-relaxed">
          <p className="font-bold text-white mb-0.5">
            {t('legal.cookieBannerTitle', 'GDPR Privacy & Cookie Notice')}
          </p>
          <p>
            {t(
              'legal.cookieBannerText',
              'We use strictly necessary cookies for language/timezone preferences and secure Stripe checkout, plus anonymous performance analytics.'
            )}{' '}
            <Link to="/privacy" className="text-emerald-400 hover:underline font-semibold">
              {t('legal.privacyLink', 'Privacy Policy')}
            </Link>{' '}
            ·{' '}
            <Link to="/terms" className="text-emerald-400 hover:underline font-semibold">
              {t('legal.termsLink', 'Terms & Refunds')}
            </Link>
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2.5 self-end sm:self-center flex-shrink-0">
        <button
          type="button"
          onClick={() => handleChoice('essential')}
          className="px-4 py-2 rounded-full text-xs font-bold bg-gray-800 hover:bg-gray-700 text-gray-200 border border-gray-700 transition-colors"
        >
          {t('legal.cookieEssentialBtn', 'Essential Only')}
        </button>
        <button
          type="button"
          onClick={() => handleChoice('all')}
          className="px-5 py-2 rounded-full text-xs font-bold bg-emerald-500 hover:bg-emerald-600 text-white shadow-md transition-colors"
        >
          {t('legal.cookieAcceptBtn', 'Accept')}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
